import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { PartnershipApplicationStatus } from '@/helpers/entities/enums/v2/PartnershipApplicationStatus';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import LinkButton from '@/components/link_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let Orders = class Orders extends mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.pending = PartnershipApplicationStatus.Pending;
        this.confirmed = PartnershipApplicationStatus.Confirmed;
        this.approved = PartnershipApplicationStatus.Approved;
        this.rejected = PartnershipApplicationStatus.Rejected;
    }
};
Orders = __decorate([
    Component({
        components: {
            ActionButton,
            LinkButton,
            PageTitle,
        },
    })
], Orders);
export default Orders;
